<body>
    <div class="header">
        <img src="../../../assets/logo-site.png" alt="Logo" class="logo">
        <span class="header-text">Olá {{aluno_}}</span>
        <button mat-button class="menu-button" (click)="isDesktop = !isDesktop">
            <mat-icon>menu</mat-icon>
        </button>
        <div class="menu" *ngIf="isDesktop">
            <ul>
                <li *ngFor="let item of menuItems">
                    <div (click)="linkSeletor(item.url,item.id)"
                        style="display: flex; justify-content: space-between; cursor: pointer;">
                        <img [src]="item.image" alt="{{ item.text }}">
                        <span>{{ item.text }}</span>
                    </div>
                </li>
            </ul>
        </div>
    </div>

    <div class="container">
        <div class="sidebar">
            <ul>
                <li *ngFor="let item of menuItems">
                    <div (click)="linkSeletor(item.url,item.id)"
                        style="display: flex; justify-content: space-between; cursor: pointer;">
                        <img [src]="item.image" alt="{{ item.text }}">
                        <span>{{ item.text }}</span>
                    </div>
                </li>
            </ul>
        </div>

        <div class="seletorVideo">
            <mat-form-field style="width: 100%;" appearance="outline">
                <mat-select [(ngModel)]="selectedMateria" (selectionChange)="opcaoSelecionada($event)">
                    <mat-option *ngFor="let materia of materiasUpper" [value]="materia.id">{{
                        materia.nomeMateria
                        }}</mat-option>
                </mat-select>
            </mat-form-field>


            <mat-form-field *ngIf="!isVideo" style="width: 100%;" appearance="outline">
                <mat-select [(ngModel)]="selectedAula" (selectionChange)="opcaoAulaSelecionada($event)">
                    <mat-option *ngFor="let aula of aulas" [value]="aula.id">{{ aula.tituloAula }}</mat-option>
                </mat-select>
            </mat-form-field>

            <div>
                <iframe [src]="videoUrl" webkitallowfullscreen mozallowfullscreen allowfullscreen
                    style="width: 100%; height: 525px; border: none;"></iframe>
            </div>
        </div>

        <div *ngIf="!isVideo" class="licoes">
            <mat-accordion *ngIf="exercicios.length > 0">
                <mat-expansion-panel expanded="true" (opened)="panelOpenState = true" (closed)="panelOpenState = false"
                    style="border: 1px solid #fff; border-radius: 10px;">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            Realizar Exercícios
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <form id="quiz-form">
                        <div #questions *ngFor="let item of exercicios; let i=index">
                            <p>{{i+1}}. {{item.descricaoPergunta}} </p>

                            <p *ngIf="item.arquivoString" class="over-auto">
                                <img [src]="item.arquivoString" alt="pergunta">
                            </p>

                            <!-- <div *ngFor="let resp of item.resposta; let index = index" color="primary"
                                [ngClass]="styleResposta(resp, item)?.class" [(ngModel)]="respondido"
                                (change)="OnResponder()"> -->
                            <div *ngFor="let resp of item.resposta;"
                                style="height: auto; border-radius: 5px;display: flex; flex-direction: row; justify-content: space-between; align-items: center; margin-bottom: 5px; padding: 5px;">
                                <input type="radio" [id]="resp.id" [value]="resp.opcao"
                                    attr.data-resposta="{{resp.correta}}" #radioBtn
                                    name="pergunta{{item.id}}">{{resp.opcao
                                + ")
                                " +
                                resp.descricao}}
                                <div
                                    style="display: flex; flex-grow: 1; justify-content: flex-end; margin-top: 5px; margin-right: 5px;;">
                                    <div id="icon-correto" class="ng-hide">
                                        <mat-icon>check</mat-icon>
                                    </div>
                                    <div id="icon-errado" class="ng-hide">
                                        <mat-icon>close</mat-icon>
                                    </div>
                                </div>
                                <input type="hidden" name="correta{{resp.id}}" value="{{resp.correta}}">

                            </div>
                            <hr>

                        </div>

                        <br><br>
                        <div _ngcontent-axy-c311=""><button _ngcontent-axy-c311="" mat-raised-button="" color="primary"
                                name="btnNameResponder" cdkfocusinitial=""
                                class="mat-focus-indicator mat-raised-button mat-button-base mat-primary"
                                (click)="verificarRespostas()"><span class="mat-button-wrapper">Responder</span>
                                <div matripple="" class="mat-ripple mat-button-ripple"></div>
                                <div class="mat-button-focus-overlay"></div>
                            </button>
                            <button _ngcontent-axy-c311="" mat-button="" id="r" color="danger"
                                class="mat-focus-indicator mat-button mat-button-base mat-danger"
                                style="background-color: red; color: white; margin-left: 15px;"
                                (click)="refazer()"><span class="mat-button-wrapper">Refazer</span>
                                <div matripple="" class="mat-ripple mat-button-ripple"></div>
                                <div class="mat-button-focus-overlay"></div>
                            </button>
                        </div>
                    </form>
                </mat-expansion-panel>
            </mat-accordion>
        </div>

        <div *ngIf="isVideo" class="licoes" style="height: calc(100vh - 150px); overflow-y: auto;">
            <mat-card *ngFor="let aula of aulas" (click)="opcaoVideoSelecionado(aula.id)">
                <mat-card-header>
                    <mat-card-title>{{ aula.tituloAula }}</mat-card-title>
                </mat-card-header>
            </mat-card>
        </div>
    </div>
</body>